const purchaseHistoryFR = {
    "view": {
        "table": {
            "title": "Votre historique d'achats",
            "column": {
                "amount": "Montant",
                "description": "Description",
                "credits_balance": "Solde de crédits",
                "tokens_balance": "Solde de jetons",
                "date_of_purchase": "Date d'achat",
                "receipt": "Reçu"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "button": {
                "view": "Voir",
                "export_csv": "Exporter CSV"
            }
        }
    }
};

export default purchaseHistoryFR;